import Oidc, { UserManager, UserManagerSettings } from "oidc-client";
import AppSettings from "../types/AppSettings";
import { getFoundationServiceSchemeAndHost } from "./getFoundationServiceSchemeAndHost";

export const createUserManager = (appSettings: AppSettings, logLevel: number = Oidc.Log.NONE): UserManager => {
    // Set Log Level
    if(logLevel < Oidc.Log.NONE) logLevel = Oidc.Log.NONE; // 0
    if(logLevel > Oidc.Log.DEBUG) logLevel = Oidc.Log.DEBUG; // 4
    Oidc.Log.level = logLevel;
    if(logLevel !== Oidc.Log.NONE) Oidc.Log.logger = window.console;

    // Build authority
    const authority = `${getFoundationServiceSchemeAndHost()}/.well-known/openid-configuration`;

    // Prepare base path
    let basePath = `/${appSettings.basePath}`; // "foo" -> "/foo", "" -> "/" 
    if(basePath !== '/') {
        basePath += '/'; // "/foo" -> "/foo/""
    }

    // Determine if we're handling a silent renwal right now
    var isSilentRenewing = false;
    if(window.location.pathname === `${basePath}silent-renew`) {
        console.debug("silent-renew-occurring")
        isSilentRenewing = true;
    }

    // Build User Manager Configuration
    const userManagerConfig: UserManagerSettings = {
        authority: authority,
        client_id: appSettings.clientId,
        redirect_uri: `${window.location.protocol}//${window.location.host}${basePath}callback`,
        post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}${basePath}`,
        silent_redirect_uri: `${window.location.protocol}//${window.location.host}${basePath}silent-renew`,
        automaticSilentRenew: !isSilentRenewing,
        accessTokenExpiringNotificationTime: 60,
        filterProtocolClaims: true,
        loadUserInfo: false,
        monitorSession: true,
        checkSessionInterval: 5000,
        scope: `openid profile ${appSettings.apiScopes.join(' ')}`,
        response_type: "token id_token"
    };

    const userManager = new UserManager(userManagerConfig);
    userManager.events.addUserSignedOut(function () {
        console.debug("user-signed-out");
        userManager.signoutRedirect().then(function (_) {
            console.debug("user-signed-out-redirect");
        }).catch(function (_) {
            console.debug("user-signed-out-redirect-error: ");
        });
    });

    return userManager;
}